import {AnimatePresence} from 'framer-motion';
import ReactDOM from 'react-dom';
import type * as React from 'react';

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
const portalRoot: HTMLElement = document.getElementById(
  'portals',
) as HTMLElement;

type Props = {
  children: React.ReactNode;
};

const Layer = (props: Props) => {
  return ReactDOM.createPortal(
    <AnimatePresence>{props.children}</AnimatePresence>,
    portalRoot,
  );
};

export default Layer;
